export enum EApprovalDescriptionStatus {
  PENDING = "pending",
  APPROVED = "approved",
  NOT_FILLED = "not_filled"
}
